import React from "react";
import { SpmIntegrationInfo } from "../../../types/spmIntegrationInfo";
import { DefaultColumnBuilder as builder } from "../../components/ColumnBuilder";
import { Button, Empty, Popconfirm, Space, Table } from "antd";
import { AnyObject } from "antd/es/_util/type";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

export interface SpmIntegrationTableProps {
  loading?: boolean;
  records: SpmIntegrationInfo[];
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const SpmIntegrationTable = (props: SpmIntegrationTableProps) => {
  const columns = [
    builder.id,
    { ...builder.text("URL", "url"), width: 260 },
    builder.text("Version", "version"),
    builder.text("Product", "product"),
    builder.text("Replaces Pod", "replacesPod"),
    {
      title: "Actions",
      key: "actions",
      width: 90,
      fixed: "right" as const,
      render: (_: unknown, record: AnyObject) => (
        <Space size="small">
          {props.onEdit && (
            <Button
              type="text"
              icon={<EditOutlined />}
              aria-label={`Edit SPM integration ${record.product}`}
              onClick={() =>
                record.id !== undefined && props.onEdit?.(record.id)
              }
            />
          )}
          {props.onDelete && (
            <Popconfirm
              title="Delete SPM integration"
              description={`Remove the SPM integration "${record.product}" (${record.version})?`}
              okText="Yes"
              cancelText="No"
              onConfirm={() => props.onDelete?.(record.id)}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                aria-label={`Delete SPM integration ${record.product}`}
              />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      loading={props.loading}
      columns={columns}
      pagination={false}
      scroll={{ x: "max-content" }}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No SPM integrations"
          />
        ),
      }}
      dataSource={(props.records || []).map((record) => ({
        ...record,
        key: record.id,
      }))}
    />
  );
};
